import { render } from "./slider.vue?vue&type=template&id=efa58572&scoped=true"
import script from "./slider.vue?vue&type=script&lang=js"
export * from "./slider.vue?vue&type=script&lang=js"

import "./slider.vue?vue&type=style&index=0&id=efa58572&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1446831496/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efa58572"]])

export default __exports__